/**
 * Created by mongoose on 14/11/17.
 */
import React from "react";
import PropTypes from "prop-types";
import { FormGroup } from "react-bootstrap-3";

/*TODO: set error style*/
function SwitchGroup({ value, onChange, field, caller, entity, disabled }) {
  const { fieldName } = field;
  return (
    <div className={`SwitchGroup ${field.className}`}>
      <FormGroup>
        <div>
          <label className="switch">
            <input
              disabled={disabled}
              type="checkbox"
              checked={caller === "list" ? entity[field.fieldName] : value}
              onChange={onChange ? event => onChange({ event, field: fieldName }) : undefined}
            />
            <em />
          </label>
        </div>
      </FormGroup>
    </div>
  );
}

SwitchGroup.propTypes = {
  field: PropTypes.object,
  formErrors: PropTypes.object,
  formValues: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default SwitchGroup;
